module.exports = __webpack_public_path__ + "static/BundesSans-Web-Medium-322998f76209a3d648ea958e44adfee0.woff";